import { Component, inject } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LayoutService } from '../service/app.layout.service';
import { Drawer } from 'primeng/drawer';

@Component({
  selector: 'app-rightmenu',
  templateUrl: './app.rightmenu.component.html',
  imports: [Drawer],
})
export class AppRightMenuComponent {
  public readonly layoutService = inject(LayoutService);

  public selectedAmount!: SelectItem;

  public amount = [
    { label: '*****24', value: { id: 1, name: '*****24', code: 'A1' } },
    { label: '*****75', value: { id: 2, name: '*****75', code: 'A2' } },
  ];

  public readonly visible = this.layoutService.rightMenuVisible;
}
